import { z } from 'zod';
import { zodParseSafe } from 'libs/end-to-end/src/utils/utility/zod-parse-safe';

export const LanguageName = z.enum(['en', 'en-pd']);

export type LanguageName = z.infer<typeof LanguageName>;

export const LanguageNames = Object.values(LanguageName.Values);

export const resolveLanguage = (input: unknown): LanguageName => {
  const code = zodParseSafe(input, LanguageName);

  if (code.resultType === 'ok') {
    return code.value;
  } else {
    return 'en';
  }
};
